<template>
  <v-container>
    <!-----------------------SEARCH BY SKU FORM--------------------------------------->
    <SearchSKU v-if="showSearch" @search="search"></SearchSKU>
    <!--------------------------------------------------------------------------------->

    <!-- SEARCH RESULTS------------------------------------------------------------------->
    <v-container v-if="results">
      <!--ALERT BOX SEARCH FAILED ---------------------------------------------------------->
      <SearchFailed v-if="searchFailed" :SKU="SKU" :noIdBox="noIdBox" @reset="proceedNew"></SearchFailed>
      <!------------------------------------------------------------------------------------>

      <!------ALERT BOX WITHOUT DESCRIPTION----------------------------------------------->
      <AlertWithoutDesc v-if="withoutDescription" @skipDescription="skipDescription"
        @writeDescription="writeDescription" :SKU="SKU"></AlertWithoutDesc>
      <!---------------------------------------------------------------------------------->

      <!------ALERT BOX WITH DESCRIPTION-------------------------------------------------->
      <AlertWithDesc v-if="hasDescription && showActions" :SKU="SKU" :writeDescription="writeDescription"
        @creatingNewVariation="creatingNewVariation"></AlertWithDesc>
      <!---------------------------------------------------------------------------------->

      <!-----------------CARD WITH INFO ABOUT PRODUCT------------------------------------->
      <ProductCard v-if="(!showSearch && withoutDescription) || hasDescription" :hasDescription="hasDescription"
        :withoutDescription="withoutDescription" :retrievedProduct="retrievedProduct" :filesToShow="filesToShow"
        @createNewVariaton="createNewVariaton" @editDescription="editDescription" @writeDescription="writeDescription"
        @proceedNew="proceedNew" :showActions="showActions"></ProductCard>
      <!---------------------------------------------------------------------------------->
    </v-container>
    <!------------------------------------------------------------------------------------>

    <!------------------WRITE DESCRIPTION FORM OR CREATE AS NEW VARIATION FORM------------>

    <ProductDialog v-if="showProductForm" :product="product" :title="title" :type="type" :fillDynamic="true"
      :excludeKeys="excludeKeys" @closeDialog="closeDialog" @closedStatusDialog="closedStatusInProduct"
      @hideResults="hideResults" @skipDescription="skipDescription" @postSkuSearch="search"
      :initialProduct="initialProduct"></ProductDialog>

    <!------------------------------------------------------------------------------------->

    <!-----------------SKIP DESCRIPTION REASON CARD----------------------------------------->
    <SkipReasonsCard v-if="showSkipReasons" :SKU="SKU" @setSkipReason="setSkipReason"
      @afterSkipSelected="afterSkipSelected" :boxLocations="boxLocations" :skipReason="skipReason">
    </SkipReasonsCard>
    <!-------------------------------------------------------------------------------------->

    <!-----------------INFO ALERT AFTER SKIP------------------------------------------------>
    <AlertLocationChange v-if="infoAlert" :SKU="SKU" :newLocation="newLocation" @changeLocation="changeLocation">
    </AlertLocationChange>
    <!-------------------------------------------------------------------------------------->

    <!-----------------IF SERVER IS COMPLETELY DOWN--------------------------------------->
    <StatusInfo v-if="failed && filename !== ''" :responseMessage="responseMessage" :filename="filename"
      :pending="false" @close="reset"></StatusInfo>
    <!----------------------------------------------------------------------------------->

    <!-----------------OLD LOCATION INPUT CARD---------------------------------------------->
    <OldLocationCard v-if="oldLocationCard" :SKU="SKU" @continueOldLocation="continueOldLocation"
      @onInputChange="setOldLocationVal"></OldLocationCard>

    <!-------------------------------------------------------------------------------------->

    <!-----------------STATUS DIALOG----------------------------------------------------->
    <v-dialog persistent v-model="statusDialog" width="unset">
      <StatusInfo :responseMessage="responseMessage" :filename="filename" :pending="pending" @close="reset"
        :textColor="textColor"></StatusInfo>
    </v-dialog>
    <!---------------------------------------------------------------------------------->
  </v-container>
</template>
<script>
import StatusInfo from "../organisms/StatusInfo";
import SearchFailed from "../Descriptions/SearchFailed";
import AlertWithoutDesc from "../Descriptions/AlertWithoutDesc";
import AlertWithDesc from "../Descriptions/AlertWithDesc";
import ProductCard from "../Descriptions/ProductCard";
import SkipReasonsCard from "../Descriptions/SkipReasonsCard";
import AlertLocationChange from "../Descriptions/AlertLocationChange";
import SearchSKU from "../Descriptions/SearchSKU";
import ProductDialog from "../ProductDialog/ProductDialog.vue";
import OldLocationCard from "../Descriptions/OldLocationCard.vue";

export default {
  name: "WriteDescriptions",
  components: {
    StatusInfo,
    SearchFailed,
    AlertWithoutDesc,
    AlertWithDesc,
    ProductCard,
    SkipReasonsCard,
    AlertLocationChange,
    SearchSKU,
    ProductDialog,
    OldLocationCard,
  },
  data: () => ({
    statusDialog: false,
    responseMessage: "",
    pending: false,
    textColor: "basic--text",
    noIdBox: "",
    described: false,
    showSearch: true,
    hasDescription: false,
    searchFailed: false,
    withoutDescription: false,
    snackbar: false,
    snackbarText: "",
    boxName: "",
    results: false,
    creatingNewVariation: false,
    retrievedProduct: {},
    showSkipReasons: false,
    skipReason: "",
    skipReasons: [],
    infoAlert: false,
    newLocation: "",
    boxLocations: [],
    failed: false,
    filename: "",
    rules: {
      required: (value) => !!value || "Field is required.",
      requiredMultiple: (value) => value.length > 0 || "Field is required",
      material: (value) => {
        if ((value < 0 || value > 100) && value != "") {
          return "Amount must be 0-100!";
        } else {
          return true;
        }
      },
      rrp: (value) => {
        if (value < 0) {
          return "Amount must be more than 0!";
        } else {
          return true;
        }
      },
    },
    showActions: true,
    valid: false,
    showProductForm: false,
    product: {},
    excludeKeys: [],
    title: "",
    type: "",
    filesToShow: [],
    oldLocationValue: "",
    oldLocationCard: false,
    SKU: "",
    db: "",
    initialProduct: undefined,
  }),
  methods: {
    //hide result container
    hideResults() {
      this.results = false;
    },
    closeDialog() {
      this.showProductForm = false;
    },
    closedStatusInProduct() {
      this.hasDescription = false;
      this.withoutDescription = false;
      this.result = false;
      this.showSearch = true;
      this.showProductForm = false;
    },

    //go back to SKU search
    proceedNew() {
      this.searchFailed = false;
      this.showSearch = true;
      this.results = false;
    },

    /*
    proceeds search when you fill in SKU value and press search button or enter key
    */
    async search(sku) {
      this.showProductForm = false;
      this.withoutDescription = false;
      this.hasDescription = false;

      this.SKU = sku;
      try {
        const response = await this.$store.dispatch("searchSKU", {
          SKU: sku,
        });

        //hide SKU search form
        this.showSearch = false;
        //show results container (alert and product card)
        this.results = true;

        //if search successful
        if (response.status == 200) {
          this.described = response.data.Described;
          this.retrievedProduct = response.data;

          // Always populate filesToShow if Photos exist
          this.filesToShow = Array.isArray(this.retrievedProduct.Photos)
            ? this.retrievedProduct.Photos
            : [];

          if (this.retrievedProduct.Described) {
            this.hasDescription = true;
          } else {
            this.withoutDescription = true;
          }
        }
      } catch (error) {
        console.log(error);
        //nothing found
        console.log(error.response.status);
        if (error.response.status == 404) {
          // get box locations to show in which box you need to put item which was not found in the system
          await this.getBoxLocations();
          //hide SKU search form
          this.showSearch = false;
          //show results container (alert and product card)
          this.results = true;
          //show SearchFailed component
          this.searchFailed = true;
        }
      }
    },
    /*
      when you press "New variation" button
    */
    createNewVariaton() {
      this.title = "New variation from " + this.retrievedProduct.SKU;
      this.type = "description";

      this.product = this.retrievedProduct;

      this.excludeKeys = ["Condition", "ConditionDescription", "Defect"];

      this.showProductForm = true;
    },
    //open write description dialog and fill fields with retrieved info
    async writeDescription() {
      let product = "";
      //at frist check IndexedDB if there exists cashed product with this SKU
      await this.$store.dispatch(
        "searchForCashedProduct",
        this.retrievedProduct.SKU
      );
      if (this.$store.state.product) {
        product = this.$store.state.product;
        //send initial product data to compare product when checking sku change
        this.initialProduct = this.retrievedProduct;
      } else {
        //field keys which should be prefilled from exact product
        let retrievedKeys = [
          "RealColor",
          "Barcode",
          "Condition",
          "ConditionDescription",
          "Defect",
          "ManufacturerColor",
          "Size",
          "Measurement",
          "Type",
          "SKU",
        ];
        product = await this.getDataBySKU();
        if (this.retrievedProduct.RealColor != product.RealColor) {
          product["Photos"] = [];
        }
        //override values which came from exact product
        for (let key of retrievedKeys) {
          if (this.retrievedProduct[key]) {
            product[key] = this.retrievedProduct[key];
          } else {
            delete product[key];
          }
        }
      }

      if (!product["ConditionDescription"]) {
        product["ConditionDescription"] = [];
      }
      if (!product["Defect"]) {
        product["Defect"] = [];
      }
      this.excludeKeys = [];
      this.title = "Describe product " + this.retrievedProduct.SKU;
      this.type = "description";
      this.product = product;

      console.log(product);
      this.showProductForm = true;
    },

    /*
    when you press "Edit"  button
    */
    async editDescription() {
      this.title = "Edit product " + this.retrievedProduct.SKU;
      this.type = "description";

      this.product = this.retrievedProduct;

      if (!this.product["ConditionDescription"]) {
        this.product["ConditionDescription"] = [];
      }
      if (!this.product["Defect"]) {
        this.product["Defect"] = [];
      }

      this.showProductForm = true;
    },

    //close status dialog
    closeStatusDialog() {
      if (this.writeDescriptionDialog) {
        this.reset();
      }
      this.statusDialog = false;
    },
    async skipDescription(sku) {
      this.SKU = sku;
      this.showProductForm = false;
      await this.getBoxLocations();
      this.results = false;
      this.writeDescriptionDialog = false;
      this.showSkipReasons = true;
    },
    setSkipReason(itm) {
      this.skipReason = itm.type;
      this.newLocation = itm.locationCode;
    },
    afterSkipSelected() {
      this.showSkipReasons = false;

      this.oldLocationCard = true;
    },
    //change product location
    changeLocation() {
      this.statusDialog = true;
      this.pending = true;
      this.$store
        .dispatch("changeLocation", {
          SKU: this.SKU.trim(),
          OldBinRack: this.oldLocationValue,
          NewBinRack: this.newLocation,
        })
        .then(() => {
          this.pending = false;
          this.textColor = "basic--text";
          this.statusDialog = true;
          this.responseMessage = `Location changed successfully for item ${this.SKU}.`;
          this.filename = "high_five.svg";
        })
        .catch((error) => {
          this.textColor = "red--text";
          this.pending = false;
          this.responseMessage = error.response.data;
          if (error.response) {
            this.showErrors(error.response.status, error.response.data);
          } else {
            // anything else
            this.filename = "feeling_blue.png";
            this.responseMessage = `SORRY... Couldn't change product ${this.SKU} location. Something went wrong.`;
          }
        });
    },
    //get box locations and assign no id box to show user where to put product if it is not found
    async getBoxLocations() {
      try {
        const response = await this.$store.dispatch("getBoxLocations");

        this.textColor = "";
        this.boxLocations = response.data;
        this.noIdBox = this.boxLocations.find(
          ({ type }) => type === "no id or registration/defect too major"
        ).locationCode;
      } catch (e) {
        console.log(e);
      }
    },
    showErrors(status, message) {
      // client received an error response (5xx, 4xx)
      this.responseMessage = message;
      switch (status) {
        case 400:
          this.filename = "empty.svg";
          break;
        case 401:
          //clear local storage, push to login
          localStorage.clear();
          this.$router.push("login");
          break;
        case 403:
          this.filename = "403_forbidden.svg";
          break;
        case 404:
          this.responseMessage = "Bad request. Please contact TECH team.";
          this.filename = "void.svg";
          break;
        case 500:
          this.filename = "server_down.svg";
      }
    },
    //resets the app
    reset() {
      this.$router.go();
    },
    /*
    get data from sku
    response quick - there is described variation of this product which data could be used to prefill fields
    response full - use all data that was retrieved at first search by SKU
    returns product data
    */
    async getDataBySKU() {
      try {
        const response = await this.$store.dispatch("getDataBySKU", {
          SKU: this.SKU,
        });
        let descriptionType = response.data.descriptionType;
        if (descriptionType == "full") {
          this.retrievedProduct["descriptionType"] = descriptionType;
          return this.retrievedProduct;
        }
        if (descriptionType == "quick") {
          let product = response.data;
          product["descriptionType"] = descriptionType;
          return product;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // sets old location value when you select it in OldLocationCard component
    setOldLocationVal(val) {
      this.oldLocationValue = val;
    },
    // when you press continue button in old location card
    continueOldLocation() {
      //if creating as new variation or new sku was generated
      //then post that product as new variation

      if (this.skipReason !== "") {
        this.oldLocationCard = false;
        this.infoAlert = true;
      }
    },
  },
  mounted() { },
};
</script>
